import * as React from 'react'
import { ScrollView, Text, View } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import Button from '@components/button/Button'

import useI18n from '@i18n/useI18n'

import { IncidentFormScheme } from '../scheme'

const GroupedFormLayout = ({
  step,
  form,
  onNext,
  onBack,
  children,
  last,
  validation = () => true,
  noHeader,
  fixed,
  loading,
}: IncidentLayoutProps) => {
  const i18n = useI18n()

  const [valid, setValid] = React.useState(false)

  React.useEffect(() => {
    const schema = IncidentFormScheme[step as keyof typeof IncidentFormScheme]

    if (schema) {
      schema
        .validate(form)
        .then(() => setValid(validation(form)))
        .catch(() => setValid(false))
    }
  }, [form])

  return (
    <MainContainer>
      {!noHeader && <Title>{i18n.t(`screens.incident.${step}.title`, form)}</Title>}

      {fixed ? <FixedContainer>{children}</FixedContainer> : <Container>{children}</Container>}

      <Buttons>
        <ButtonContainer>
          <Button
            label={i18n.t('screens.incident.previous')}
            status="active"
            onClick={onBack}
            textOnly
            color="light"
            textColor={theme.colors.primaryText}
          />
        </ButtonContainer>
        <ButtonContainer>
          <Button
            label={i18n.t(`screens.incident.${last ? 'declare' : 'next'}`)}
            status={loading ? 'loading' : valid ? 'active' : 'disabled'}
            onClick={onNext}
          />
        </ButtonContainer>
      </Buttons>
    </MainContainer>
  )
}

export default GroupedFormLayout

const MainContainer = styled(View)`
  flex: 1;
  flex-direction: column;
`

const Container = styled(ScrollView)`
  flex: 1;
`

const FixedContainer = styled(View)`
  flex: 1;
`

const Title = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  margin: 25px 15px;
`

const Buttons = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.background};
`

const ButtonContainer = styled(View)`
  margin: 12px;
`
